<template>
    <v-container>
        <create-link @create="$refs.list.update()"></create-link>

        <link-list ref="list"></link-list>
    </v-container>
</template>

<script>
import CreateLink from './components/CreateLink.vue'
import LinkList from './components/LinkList.vue'

export default {
    components: {
        CreateLink,
        LinkList
    }
}
</script>
